import * as React from "react";
import { SVGProps } from "react";
const LogoPayInFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="svg-early-registration"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 39.9 40.2"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path
        fill="currentColor"
        d="M27.9,20.6c-0.4,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h0.8c-0.1-2.2-1.1-4.3-2.7-5.9s-3.7-2.5-5.9-2.7v0.8 c0,0.4-0.3,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6v-0.8c-2.2,0.1-4.3,1.1-5.9,2.7s-2.5,3.7-2.7,5.9h0.8c0.4,0,0.6,0.3,0.6,0.6 s-0.3,0.6-0.6,0.6h-0.8c0.1,2.2,1.1,4.3,2.7,5.9s3.7,2.5,5.9,2.7v-0.8c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6v0.8 c2.2-0.1,4.3-1.1,5.9-2.7s2.5-3.7,2.7-5.9C28.7,20.6,27.9,20.6,27.9,20.6z M13.4,13.9c0.2-0.2,0.6-0.2,0.9,0l0.9,0.9 c0.2,0.2,0.2,0.6,0,0.9c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3-0.1-0.4-0.2l-0.9-0.9C13.2,14.6,13.2,14.2,13.4,13.9z M15.2,25.1l-0.9,0.9 c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.6,0-0.9l0.9-0.9c0.2-0.2,0.6-0.2,0.9,0S15.5,24.9,15.2,25.1z  M19.5,21.7c-0.9,0-1.7-0.8-1.7-1.7c0-0.7,0.4-1.3,1-1.6v-3.4c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6v3.4 c0.6,0.2,1,0.9,1,1.6C21.2,20.9,20.4,21.7,19.5,21.7z M25.6,26.1c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3-0.1-0.4-0.2l-0.9-0.9 c-0.2-0.2-0.2-0.6,0-0.9s0.6-0.2,0.9,0l0.9,0.9C25.8,25.4,25.8,25.8,25.6,26.1z M25.6,14.8l-0.9,0.9c-0.1,0.1-0.3,0.2-0.4,0.2 s-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.6,0-0.9l0.9-0.9c0.2-0.2,0.6-0.2,0.9,0S25.8,14.6,25.6,14.8z"
      />
      <path
        fill="currentColor"
        d="M19.5,1.3C9.2,1.3,0.8,9.7,0.8,20s8.4,18.7,18.7,18.7S38.2,30.3,38.2,20S29.8,1.3,19.5,1.3z M26.9,27.4 c-2,2-4.6,3.1-7.4,3.1l0,0l0,0l0,0c-2.8,0-5.4-1.1-7.4-3.1c-2-2-3.1-4.6-3.1-7.4s1.1-5.4,3.1-7.4c1.8-1.8,4.2-2.9,6.8-3V8.7h-1.5 c-0.4,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h1.5h0.6h2.1c0.4,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6h-1.5v0.9 c2.6,0.1,4.9,1.2,6.8,3c2,2,3.1,4.6,3.1,7.4C30,22.8,28.9,25.4,26.9,27.4z"
      />
    </g>
  </svg>
);
export default LogoPayInFull;
